module.exports = __webpack_public_path__ + "mainassets/img/button-arrow.46ee0f3a.svg";